export function getCtaButtonHrefWithSessionId(
  afterRegistrationRedirect?: string
) {
  return `/users/sign_up?session_id=${localStorage.getItem('uuid')}${
    afterRegistrationRedirect ? '&redirect=' + afterRegistrationRedirect : ''
  }`;
}

export const getRandomDelay = (min = 1.8, max = 2.4): number => {
  return Number((Math.random() * (max - min + 1) + min).toFixed(1));
};

export const getVisibleBonusCode = (
  hiddenBonusCodes: string[],
  name: string
) => {
  return hiddenBonusCodes.includes(name) ? '' : name;
};

export const REG_MODAL_FLOW = 'regModal';
